var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUsers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3571 21.887C18.468 21.887 21.8006 18.5545 21.8006 14.4435C21.8006 10.3326 18.468 7 14.3571 7C10.2461 7 6.91355 10.3326 6.91355 14.4435C6.91355 18.5545 10.2461 21.887 14.3571 21.887ZM14.5 24.3969C6.49187 24.3969 0 30.8888 0 38.8969V40.0569H29V40.0263H40V39.0663C40 32.4389 34.6274 27.0663 28 27.0663C26.538 27.0663 25.1371 27.3278 23.8414 27.8065C21.3182 25.679 18.0588 24.3969 14.5 24.3969ZM27.8817 24.9892C31.2839 24.9892 34.0419 22.2312 34.0419 18.829C34.0419 15.4269 31.2839 12.6689 27.8817 12.6689C24.4796 12.6689 21.7216 15.4269 21.7216 18.829C21.7216 22.2312 24.4796 24.9892 27.8817 24.9892Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon_Users.889c37492c24c2310addb360825c8a8c.svg";
export { ForwardRef as ReactComponent };